import React, { useState, useEffect } from 'react';
import './App.css'
import { space6 } from './dist/helpers'
import { LandingPage } from './dist/LandingPage'
import { getCounter } from './api.jsx'
import { LoadingSpinner } from './dist/LoadingComponent'

function App(props) {
  console.log("Welcome to Andrew Dilks .com!!")
  const { dark } = props;
  const [visits, setVisits] = useState("loading");

  useEffect(() => {
    getCounter().then(count => {
      setVisits(count);
    });
  }, []); // Empty dependency array means it runs once on mount

  return (
    <>
      <div>
        <>
          <center>
            <div style={{display: "flex", alignItems: "center", justifyContent: "center"}}>
              <h1> Number visits: {visits === "loading" ? (<></>): (visits) } </h1>
              { visits === "loading" ? (<LoadingSpinner />): (<></>)}
            </div>
          </center>
        </>
        { LandingPage(dark) }
        { space6 }
        { space6 }
      </div>
    </>
  )
}

export default App;
